import { Root } from './ui/root';
import { Trigger } from './ui/trigger';
import { Content } from './ui/content';
import { Item } from './ui/item';
import { Separator } from './ui/separator';
import { Sub } from './ui/sub';
import { SubTrigger } from './ui/sub-trigger';
import { SubContent } from './ui/sub-content';
import { Label } from './ui/label';

export const Dropdown = {
  Root,
  Trigger,
  Content,
  Item,
  Separator,
  Label,
  Sub,
  SubTrigger,
  SubContent,
};
